module.exports = __webpack_public_path__ + "static/media/system.ee0b084c.jpg";